var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnima2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8474 0.816407C10.859 0.823292 5.33832 0.861846 1.90801 4.98993C1.31945 5.70147 0.826438 6.48703 0.441518 7.32661L0.360352 7.74382C0.704363 8.82805 1.32145 9.80537 2.1522 10.5817C3.39459 11.6699 5.00032 12.2509 6.65074 12.2093H6.69476C7.19252 12.2062 7.68927 12.1643 8.18052 12.084C10.1563 11.7942 11.9553 10.7834 13.2314 9.24607C14.3818 7.82765 15.0318 6.06855 15.0803 4.24225V4.2037C15.0814 3.56342 14.9804 2.92708 14.7811 2.31866C14.6241 1.8465 14.4051 1.39735 14.1297 0.983018C13.4068 0.871818 12.6765 0.816119 11.9451 0.816407H11.8474Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48194 1.78716C5.82261 2.69166 5.4754 3.78642 5.49281 4.90594C5.49281 6.74073 6.44136 8.66157 7.6107 8.66157C8.78005 8.66157 9.72859 6.74073 9.72859 4.90594C9.72859 3.34586 9.04074 1.72382 8.11834 1.27356C7.56289 1.41111 7.0164 1.58263 6.48194 1.78716Z",
    fill: "url(#paint0_radial_4014_41564)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81659 4.5327L5.68095 3.54405C5.67521 3.53981 5.66924 3.5359 5.66306 3.53235C5.55134 3.98283 5.4943 4.44515 5.49316 4.90929C5.49316 5.00775 5.49316 5.1062 5.50142 5.20396L6.72992 4.9031C6.76748 4.89329 6.80165 4.8734 6.82875 4.84558C6.85585 4.81776 6.87485 4.78306 6.88369 4.74523C6.89254 4.7074 6.89091 4.66787 6.87896 4.6309C6.86701 4.59393 6.84521 4.56093 6.8159 4.53545",
    fill: "#FCFBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3792 5.55445L5.55859 5.75548C5.62723 6.21471 5.7527 6.6636 5.9321 7.09181L6.60756 5.86426C6.62789 5.82882 6.63748 5.78823 6.63516 5.74743C6.63285 5.70664 6.61873 5.66739 6.59453 5.63448C6.57032 5.60158 6.53708 5.57642 6.49885 5.56209C6.46062 5.54776 6.41905 5.54486 6.3792 5.55376",
    fill: "#FCFBFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4014_41564",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.61039 4.96756) scale(2.1182 3.694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40403E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnima2);
export default __webpack_public_path__ + "static/media/anima-2.f8a0c44b8821e57e4cfbf35b5f903919.svg";
export { ForwardRef as ReactComponent };